import { Card, CardContent, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { ChartLoader } from "../components/ShimmerLoader";
import ChartComponent from "../Highcharts/ChartComponent";
import { reportBarConfig } from "../Highcharts/chartConfig";
import Filter from "../components/Filter";
import nodata from "../assets/images/nodata.png";
import {
  surveyCountForOpenDashboard,
  surveyDependentCountForOpenDashboard,
} from "../services/urls";
import API from "../services/apiMiddleware";

function CategoryPage() {
  const { id } = useParams();
  const [surveyName, setSurveyName] = useState("");
  const [loading, setLoading] = useState(false);
  const [categoryLists, setCategoryLists] = useState([]);
  const [depCategoryLists, setDepCategoryLists] = useState([]);
  const [numPercentKeys, setNumPercentKeys] = useState({});

  const surveyCategoryLists = useSelector((state) => state.surveyCategoryLists);
  const globalFilters = useSelector(
    (state) => state.filterPayload.globalFilters
  );
  const communityId = useSelector((state) => state.communityData.communityId);

  useEffect(() => {
    let payload = {
      communityId,
      surveyId: id,
    };
    if (globalFilters !== null) {
      payload.globalFilters = { ...globalFilters };
    }
    getSurveyLists(payload);
  }, [id, globalFilters]);

  useEffect(() => {
    if (surveyCategoryLists) {
      const category = surveyCategoryLists.find((c) => c.categoryId == id);

      if (category) {
        setSurveyName(category.categoryLabel);
      }
    }
  }, [surveyCategoryLists, id]);

  const getSurveyLists = async (oRequest) => {
    setLoading(true);
    API.post(surveyCountForOpenDashboard, oRequest)
      .then(({ data }) => {
        const surveyCounts = data.data || [];

        const filterCategryList = surveyCounts.filter(
          ({ questionId }) => questionId !== 2117 && questionId !== 2118
        );

        const categoryWiseCounts = filterCategryList.map((survey) => {
          const categoryArr = Object.keys(survey.optionCounts);
          const chartValues = Object.values(survey.optionCounts);

          const total = chartValues.reduce((a, b) => a + b, 0) || 1;

          return {
            name: survey.name,
            categoryArr,
            chartValues,
            percentageCount: chartValues.map(
              (count) => Math.round((count / total) * 100) || 0
            ),
          };
        });
        setCategoryLists(categoryWiseCounts);
        setLoading(false);

        // As discussed with backend person below condition is added
        API.post(surveyDependentCountForOpenDashboard, oRequest)
          .then(({ data }) => {
            const depSurveyCounts = data.data;
            const depCategoryWiseCounts = Object.keys(depSurveyCounts).map(
              (surveyName) => {
                const categoryArr = Object.keys(depSurveyCounts[surveyName]);
                const chartValues = Object.values(depSurveyCounts[surveyName]);

                const total = chartValues.reduce((a, b) => a + b, 0);

                const percentageCount = chartValues.map((count) => {
                  const percentage = Math.round((count / total) * 100);
                  return percentage ? percentage : 0;
                });

                return {
                  name: surveyName,
                  categoryArr,
                  chartValues,
                  percentageCount,
                };
              }
            );
            setDepCategoryLists(depCategoryWiseCounts);
          })
          .catch((error) => {
            console.error("Error fetching depedent category data:", error);
            setDepCategoryLists(null);
          });
      })
      .catch((error) => {
        console.error("Error fetching survey count data:", error);
        setLoading(false);
      });
  };

  const handleToggle = (categoryName, key) => {
    setNumPercentKeys((prev) => ({
      ...prev,
      [categoryName]: key,
    }));
  };

  return (
    <div class="category-page-main-section">
      <hr class="divider" />
      <Filter />
      <hr class="divider" />
      <div className="category-list-container">
        <div className="category-name">{surveyName}</div>
        <div className="main-OverviewSection">
          <Grid container spacing={2} className="formscardsection">
            {categoryLists && categoryLists.length > 0 ? (
              categoryLists.map((category) => {
                const selectedKey = numPercentKeys[category.name] || "percent"; // Default to 'percent'
                return (
                  <Grid key={category.name} size={{ xs: 12, lg: 12 }}>
                    <Card className="formcard">
                      <CardContent className="formcardcontent">
                        {!loading ? (
                          <>
                            <div className="cardheader">
                              <Typography>{category.name}</Typography>
                            </div>
                            <div className="col-12 percent-number-button">
                              <button
                                onClick={() =>
                                  handleToggle(category.name, "percent")
                                }
                                className={`button ${
                                  selectedKey === "percent" ? "active" : ""
                                }`}
                              >
                                %
                              </button>
                              <button
                                onClick={() =>
                                  handleToggle(category.name, "num")
                                }
                                className={`button ${
                                  selectedKey === "num" ? "active" : ""
                                }`}
                              >
                                #
                              </button>
                            </div>
                            <ChartComponent
                              options={reportBarConfig(category, selectedKey)}
                            />
                          </>
                        ) : (
                          <ChartLoader />
                        )}
                      </CardContent>
                    </Card>
                  </Grid>
                );
              })
            ) : (
              <div className="nodatadiv">
                <img className="nodata" src={nodata} alt="nodata" />
                <p className="surveyHeaderError">Loading...</p>
              </div>
            )}

            {depCategoryLists &&
              depCategoryLists.map((depCategory) => {
                const selectedKey =
                  numPercentKeys[depCategory.name] || "percent"; // set default to 'percent'
                return (
                  <Grid size={{ xs: 12, lg: 4 }}>
                    <Card className="formcard">
                      <CardContent className="formcardcontent">
                        {!loading ? (
                          <>
                            <div className="cardheader">
                              <Typography>{depCategory.name}</Typography>
                            </div>
                            <div className="col-12 percent-number-button">
                              <button
                                onClick={() =>
                                  handleToggle(depCategory.name, "percent")
                                }
                                className={`button ${
                                  selectedKey === "percent" ? "active" : ""
                                }`}
                              >
                                %
                              </button>
                              <button
                                onClick={() =>
                                  handleToggle(depCategory.name, "num")
                                }
                                className={`button ${
                                  selectedKey === "num" ? "active" : ""
                                }`}
                              >
                                #
                              </button>
                            </div>
                            <ChartComponent
                              options={reportBarConfig(
                                depCategory,
                                selectedKey
                              )}
                            />
                          </>
                        ) : (
                          <ChartLoader />
                        )}
                      </CardContent>
                    </Card>
                  </Grid>
                );
              })}
          </Grid>
        </div>
      </div>
    </div>
  );
}

export default CategoryPage;
